import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@components/Box'
import Icon from '@components/Icon'
import useMediaQuery from '@hooks/useMediaQuery'
import { graphql, useStaticQuery } from 'gatsby'
import Image from '@components/Image'
import { getImage } from 'gatsby-plugin-image'
import theme from '@themes/index'

const ModalContent = ({ isOpen, closePortal, children }) => {
  const data = useStaticQuery(graphql`
    query {
      background: file(relativePath: {eq: "modal/background.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
          )
        }
      }
    }
  `)

  const sm = useMediaQuery(`(max-height: 550px)`)
  const md = useMediaQuery(`(max-height: 650px)`)
  const lg = useMediaQuery(`(max-height: 750px)`)
  const xl = useMediaQuery(`(max-height: 875px)`)

  const getPortraitWidth = () => {
    if (sm) return ['90%', '90%', '60%', '50%', '40%', '30%']
    if (md) return ['90%', '90%', '80%', '80%', '60%', '40%']
    if (lg) return ['90%', '90%', '80%', '80%', '80%', '50%']
    if (xl) return ['90%', '90%', '80%', '80%', '80%', '60%']
    return ['90%', '90%', '80%', '80%', '80%', '75%']
  }

  const handleKeydown = (e, func = () => { }) => {
    if (e.key === 'Escape' && isOpen) {
      closePortal()
    }

    if (e.key === 'Enter') {
      func(e)
    }
  }

  return (
    <Box
      position="fixed"
      bg="black"
      width={getPortraitWidth()}
      maxWidth="780px"
      left="50%"
      top="50%"
      overflow="hidden"
      p={'16px 28px 28px'}
      zIndex={10000}
      transform="translate(-50%, -50%)"
      fadeIn
      isMounted={isOpen}
    >
      <Image
        image={getImage(data?.background)}
        alt=""
        position="absolute"
        top="0"
        right="0"
        bottom="0"
        left="0"
        width="100%"
        height="100%"
        zIndex="-100"
      />
      <Box display="flex" justifyContent="flex-end" alignContent="center">
        <Box
          color="white"
          tabIndex={0}
          id="modal-close-button"
          role="button"
          onClick={closePortal}
          onKeyDown={e => handleKeydown(e, closePortal)}
          cursor="pointer"
        >
          <Icon glyph="close" height={21} width={21} viewBox="0 0 21 21" fill={theme.colors.tanDark} />
        </Box>
      </Box>
      <Box display="flex" flexDirection={'column'} alignItems={'center'}>
        <Box my={3} width={'100%'}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}

ModalContent.propTypes = {
  isOpen: PropTypes.bool,
  closePortal: PropTypes.func,
  children: PropTypes.node,
}

export default ModalContent
